import { Grid, GridItem, Input, Textarea } from '@chakra-ui/react'
import React from 'react'

import { CharCount } from '../../../../components/CharCount'
import { FormField } from '../../../../components/FormField'
import { RichTextField } from '../../../../components/RichTextField'
import { FormSelect } from '../../../../components/Select'
import { TCourseAgeType } from '../../../../services/CoursesService/interfaces'
import { IFormData } from './CoursesModal'

export const HERO_DESCRIPTION_MAX_LENGTH = 220

interface IProps {
  formData: IFormData
  setFormData: React.Dispatch<React.SetStateAction<IFormData>>
  errors: Record<string, string[]>
}

/**
 * Textos da página do curso presencial no site (ABRA-406). Tudo é opcional: sem descrição, o
 * topo usa um texto padrão; sem vídeo, ele fica em uma coluna; sem pré-requisitos nem idade, o
 * card ao lado do "Sobre o curso" não aparece.
 */
export function CoursePageTab({ formData, setFormData, errors }: IProps) {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <GridItem colSpan={2}>
        <FormField
          label="Descrição do topo"
          htmlFor="hero_description"
          error={errors.hero_description}
          helperText="Vazia, o site mostra: Aprenda {nome do curso} na ABRA, em Moema: aulas presenciais com professores atuantes no mercado e certificado ao concluir."
        >
          <Textarea
            id="hero_description"
            value={formData.hero_description}
            onChange={(e) => setFormData((prev) => ({ ...prev, hero_description: e.target.value }))}
            maxLength={HERO_DESCRIPTION_MAX_LENGTH}
            rows={3}
          />
          <CharCount value={formData.hero_description} max={HERO_DESCRIPTION_MAX_LENGTH} />
        </FormField>
      </GridItem>

      <GridItem colSpan={2}>
        <FormField
          label="Vídeo do topo"
          htmlFor="hero_video_url"
          error={errors.hero_video_url}
          helperText="Link do YouTube. Sem vídeo, o topo fica em uma coluna."
        >
          <Input
            id="hero_video_url"
            type="url"
            value={formData.hero_video_url}
            onChange={(e) => setFormData((prev) => ({ ...prev, hero_video_url: e.target.value }))}
            placeholder="https://www.youtube.com/watch?v=..."
            maxLength={255}
          />
        </FormField>
      </GridItem>

      <GridItem colSpan={2}>
        <RichTextField
          label="Sobre o curso"
          error={errors.about}
          value={formData.about}
          onChange={(about) => setFormData((prev) => ({ ...prev, about }))}
          minH="250px"
        />
      </GridItem>

      <GridItem colSpan={2}>
        <RichTextField
          label="Pré-requisitos"
          error={errors.prerequisites}
          value={formData.prerequisites}
          onChange={(prerequisites) => setFormData((prev) => ({ ...prev, prerequisites }))}
          minH="80px"
        />
      </GridItem>

      <GridItem>
        <FormField label="Idade" htmlFor="age_type" error={errors.age_type}>
          <FormSelect
            id="age_type"
            value={formData.age_type}
            // "Sem idade" leva o valor junto: a API recusa valor sem o tipo.
            onChange={(value) =>
              setFormData((prev) => ({
                ...prev,
                age_type: value as TCourseAgeType | '',
                age_value: value ? prev.age_value : ''
              }))
            }
            options={[
              { value: 'minimum', label: 'Idade mínima' },
              { value: 'range', label: 'Faixa etária' }
            ]}
            placeholder="Sem idade"
          />
        </FormField>
      </GridItem>

      <GridItem>
        <FormField label="Valor da idade" htmlFor="age_value" error={errors.age_value}>
          <Input
            id="age_value"
            value={formData.age_value}
            onChange={(e) => setFormData((prev) => ({ ...prev, age_value: e.target.value }))}
            placeholder={formData.age_type === 'range' ? 'Ex.: De 7 a 12 anos' : 'Ex.: 14 anos'}
            maxLength={100}
            isDisabled={!formData.age_type}
          />
        </FormField>
      </GridItem>
    </Grid>
  )
}
